import { Icon } from '@chakra-ui/react';

const PCBlogIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 30 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>

		<g>
			<path class="st0" d="M0.65,3.16C0.83,2.85,0.97,2.51,1.2,2.24c0.38-0.43,0.92-0.52,1.48-0.52c7.14,0,14.27,0,21.41,0
		c1.11,0,2.22-0.01,3.33,0c0.98,0.01,1.68,0.54,1.88,1.43c0.04,0.17,0.04,0.35,0.04,0.53c0,7.51-0.01,15.02,0.01,22.53
		c0,1-0.64,1.99-2,1.99c-3.07-0.02-6.15,0-9.22-0.01c-0.2,0-0.39,0-0.58-0.04c-0.27-0.05-0.44-0.26-0.44-0.53
		c0-0.26,0.15-0.47,0.41-0.53c0.13-0.03,0.28-0.04,0.41-0.04c3.13,0,6.26,0,9.39,0c0.68,0,0.9-0.22,0.9-0.9c0-5.86,0-11.71,0-17.57
		c0-0.1,0-0.2,0-0.33c-8.82,0-17.62,0-26.46,0c0,0.1,0,0.2,0,0.3c0,5.88,0,11.75,0,17.63c0,0.65,0.23,0.88,0.87,0.88
		c3.37,0,6.74,0,10.12,0c0.14,0,0.28,0.01,0.42,0.04c0.27,0.06,0.43,0.29,0.42,0.55c-0.01,0.25-0.18,0.46-0.43,0.51
		c-0.14,0.03-0.28,0.04-0.42,0.04c-3.34,0-6.69,0-10.03,0c-1.1,0-1.63-0.36-2.02-1.4c-0.01-0.01-0.03-0.02-0.04-0.04
		C0.65,18.89,0.65,11.03,0.65,3.16z M1.77,7.07c8.83,0,17.63,0,26.45,0c0-1.19,0.01-2.37-0.01-3.54c0-0.34-0.21-0.58-0.49-0.64
		c-0.14-0.03-0.3-0.03-0.45-0.03c-8.19,0-16.38,0-24.57,0c-0.07,0-0.15,0-0.22,0C2.05,2.88,1.78,3.1,1.78,3.53
		C1.76,4.7,1.77,5.88,1.77,7.07z"/>
			<path class="st0" d="M10.01,16.08c0.35,0.38,0.58,0.82,0.6,1.35c0.05,1.2-0.83,2.1-2.09,2.13c-0.56,0.02-1.12,0.01-1.68,0
		c-0.48-0.01-0.7-0.23-0.7-0.71c0-1.85,0-3.69,0-5.54c0-0.46,0.2-0.71,0.64-0.71c0.68-0.01,1.36-0.01,2.04,0.04
		c0.79,0.06,1.34,0.5,1.64,1.22c0.3,0.72,0.19,1.4-0.29,2.03C10.13,15.94,10.07,16.01,10.01,16.08z M7.31,13.75c0,0.6,0,1.16,0,1.74
		c0.5,0,0.98,0.02,1.46-0.01c0.4-0.03,0.73-0.45,0.73-0.86c0-0.41-0.33-0.84-0.73-0.86C8.29,13.73,7.81,13.75,7.31,13.75z
		 M7.3,18.41c0.48,0,0.93,0.01,1.39,0c0.42-0.02,0.76-0.36,0.81-0.79c0.05-0.4-0.23-0.88-0.64-0.93c-0.51-0.06-1.03-0.01-1.56-0.01
		C7.3,17.25,7.3,17.81,7.3,18.41z"/>
			<path class="st0" d="M15.02,23.91c2.66,0,5.32,0,7.98,0c0.54,0,0.83,0.21,0.83,0.58c-0.01,0.37-0.29,0.56-0.81,0.56
		c-5.35,0-10.7,0-16.05,0c-0.53,0-0.81-0.2-0.81-0.57c-0.01-0.37,0.28-0.58,0.83-0.58C9.66,23.91,12.34,23.91,15.02,23.91z"/>
			<path class="st0" d="M22.69,19.35c-0.51,0.24-1.01,0.26-1.52,0.1c-0.96-0.3-1.53-1.27-1.36-2.29c0.16-0.96,1.04-1.68,2.03-1.67
		c1,0.02,1.89,0.77,1.95,1.76c0.06,1.08,0.06,2.16,0,3.24c-0.06,0.98-0.96,1.72-1.97,1.75c-0.95,0.02-1.85-0.72-2-1.66
		c-0.03-0.17-0.04-0.36-0.01-0.52c0.05-0.26,0.31-0.44,0.56-0.42c0.26,0.02,0.46,0.21,0.51,0.47c0.02,0.1,0.03,0.2,0.05,0.3
		c0.1,0.43,0.48,0.7,0.93,0.67c0.43-0.02,0.78-0.34,0.82-0.78C22.7,20.02,22.69,19.7,22.69,19.35z M22.69,17.51
		c0-0.49-0.41-0.89-0.89-0.9c-0.49,0-0.92,0.43-0.91,0.92c0.01,0.5,0.42,0.89,0.93,0.88C22.32,18.41,22.7,18.02,22.69,17.51z"/>
			<path class="st0" d="M16.82,15.49c1.11,0,2.04,0.92,2.04,2.03c0,1.1-0.92,2.03-2.03,2.04c-1.1,0.01-2.03-0.93-2.04-2.03
		C14.78,16.43,15.72,15.5,16.82,15.49z M16.82,18.42c0.51,0,0.92-0.4,0.91-0.9c-0.01-0.48-0.42-0.89-0.9-0.9
		c-0.49-0.01-0.9,0.41-0.9,0.91C15.93,18.03,16.32,18.41,16.82,18.42z"/>
			<path class="st0" d="M12.8,15.47c0,0.71,0,1.42,0,2.13c0,0.49,0.21,0.73,0.69,0.82c0.24,0.04,0.45,0.12,0.55,0.37
		c0.16,0.4-0.16,0.79-0.61,0.76c-1.03-0.08-1.74-0.8-1.76-1.88c-0.03-1.47-0.01-2.95-0.01-4.42c0-0.26,0.09-0.48,0.34-0.59
		c0.21-0.09,0.45-0.08,0.59,0.1c0.11,0.15,0.19,0.37,0.2,0.56C12.81,14.03,12.8,14.75,12.8,15.47z"/>
			<path class="st0" d="M14.83,27.58c0.02-0.3,0.29-0.54,0.59-0.52c0.3,0.02,0.54,0.29,0.53,0.58c-0.02,0.31-0.29,0.55-0.61,0.52
		C15.03,28.14,14.81,27.89,14.83,27.58z"/>
			<path class="st1" d="M1.77,7.07c0-1.19-0.01-2.37,0.01-3.54C1.78,3.1,2.05,2.88,2.49,2.86c0.07,0,0.15,0,0.22,0
		c8.19,0,16.38,0,24.57,0c0.15,0,0.3,0,0.45,0.03c0.28,0.06,0.49,0.3,0.49,0.64c0.01,1.17,0.01,2.35,0.01,3.54
		C19.4,7.07,10.6,7.07,1.77,7.07z M20.12,4.4c-1.71,0-3.42,0-5.13,0c-0.54,0-0.83,0.21-0.82,0.58c0.01,0.37,0.29,0.56,0.82,0.56
		c3.44,0,6.87,0,10.31,0c0.12,0,0.24-0.01,0.36-0.03c0.28-0.06,0.45-0.28,0.44-0.56C26.09,4.6,25.83,4.4,25.36,4.4
		C23.62,4.4,21.87,4.4,20.12,4.4z M10.52,4.98c0-0.31-0.26-0.57-0.57-0.56C9.66,4.42,9.4,4.68,9.4,4.97c0,0.31,0.27,0.57,0.58,0.56
		C10.28,5.53,10.52,5.28,10.52,4.98z M7.18,4.41c-0.31,0-0.56,0.27-0.55,0.58c0.01,0.3,0.26,0.54,0.56,0.54
		c0.3,0,0.56-0.26,0.56-0.55C7.76,4.69,7.48,4.41,7.18,4.41z M4.97,4.99c0-0.31-0.25-0.58-0.56-0.57c-0.29,0-0.55,0.26-0.56,0.55
		C3.84,5.27,4.1,5.53,4.41,5.53C4.72,5.53,4.96,5.29,4.97,4.99z"/>
			<path class="st0" d="M20.12,4.4c1.75,0,3.49,0,5.24,0c0.47,0,0.72,0.19,0.74,0.55c0.01,0.28-0.16,0.51-0.44,0.56
		c-0.12,0.02-0.24,0.03-0.36,0.03c-3.44,0-6.87,0-10.31,0c-0.53,0-0.81-0.19-0.82-0.56c-0.01-0.38,0.28-0.58,0.82-0.58
		C16.7,4.4,18.41,4.4,20.12,4.4z"/>
			<path class="st0" d="M10.52,4.98c0,0.31-0.24,0.55-0.55,0.55C9.66,5.54,9.39,5.28,9.4,4.97c0-0.29,0.26-0.55,0.55-0.56
		C10.25,4.4,10.52,4.67,10.52,4.98z"/>
			<path class="st0" d="M7.18,4.41c0.3,0,0.58,0.28,0.57,0.57C7.75,5.28,7.49,5.53,7.19,5.53c-0.31,0-0.55-0.23-0.56-0.54
		C6.62,4.68,6.87,4.41,7.18,4.41z"/>
			<path class="st0" d="M4.97,4.99c0,0.31-0.25,0.54-0.55,0.55c-0.31,0-0.57-0.26-0.57-0.57c0.01-0.29,0.27-0.55,0.56-0.55
		C4.71,4.41,4.97,4.68,4.97,4.99z"/>
		</g>

	</Icon>
);

export default PCBlogIcon;
